
<template>
	<div class="d-flex justify-center">
		<font-awesome-icon
			v-if="!gameData.loaded"
			icon="sync"
			spin
			size="2x"
			class="d-flex"
		/>
		<canvas v-else id="game" ref="gameCanvas" width="500" height="590"></canvas>
	</div>
</template>
<script>
import Vue from 'vue';
import $ from 'jquery';
import createjs from 'createjs';
import p2 from 'p2';
import gsap from 'gsap';
import shuffle from 'lodash/shuffle';
import random from 'lodash/random';

function getAnglePositionByValue(x, y, radius, angle) {
	var position = { x: 0, y: 0 };
	position.x = x + radius * Math.cos((angle * Math.PI) / 180);
	position.y = y + radius * Math.sin((angle * Math.PI) / 180);

	return position;
}

function pad(str, max) {
	str = str.toString();
	return str.length < max ? pad('0' + str, max) : str;
}

$.sound = {};
function playSoundLoop(sound) {
	if ($.sound[sound] == null) {
		$.sound[sound] = createjs.Sound.play(sound);
		$.sound[sound].removeAllEventListeners();
		$.sound[sound].addEventListener('complete', function () {
			$.sound[sound].play();
		});
	}
}

function stopSoundLoop(sound) {
	if ($.sound[sound] != null) {
		$.sound[sound].stop();
		$.sound[sound] = null;
	}
}

function setSoundVolume(sound, vol) {
	if ($.sound[sound] != null) {
		$.sound[sound].volume = vol;
	}
}

var ballsContainer,
	ballsRevealContainer,
	itemBall,
	itemBallBg,
	itemBallShadow,
	itemBallDim,
	itemBallGuess,
	itemBallHit,
	itemSphere,
	itemStick,
	itemShine,
	itemBar;

function centerReg(obj) {
	obj.regX = obj.image.naturalWidth / 2;
	obj.regY = obj.image.naturalHeight / 2;
}

var scaleX = 50,
	scaleY = -50;

var ballRadius = 60;
var numberStartZero = true; //number start from zero instead of one
var spinDirection = true; //true for anticlockwise

var radiusTweenData = { radius: 0 };
var soundTweenData = { volume: 0 };

function updateBallsVolume() {
	setSoundVolume('soundBalls', soundTweenData.volume);
	setSoundVolume('soundCage', soundTweenData.volume);
}

var stageW = 500;
var stageH = 590;

export default Vue.extend({
	name: 'RouletteSpinner',
	props: {
		revealArray: {
			type: Array,
			required: true
		},
		settings: {
			type: Object,
			required: false,
			default: () => ({
				totalBall: 15,
				spinStartSpeed: 5,
				spinEndSpeed: 5,
				spinSpeed: 10,
				revealTimer: 5,
				rotateBalls: false,
				padNumbers: false,
				maxNumber: 10
			})
		},
		manifest: {
			type: Array,
			required: false,
			default: () => []
		}
	},
	data() {
		return {
			status: {
				spinning: false
			},
			world: new p2.World({ gravity: [0, -10] }),
			loader: new createjs.LoadQueue(false),
			canvasContainer: new createjs.Container(),
			stage: null,
			gameData: {
				loaded: false,
				sphereX: 120,
				sphereY: 230,
				cageRadius: 225,
				radius: 0,
				numberNum: 0,
				winArray: [],
				ballsArray: [],
				cageArray: [],
				totalBall: [],
				ballNumber: []
			},
			canvas: {
				width: null,
				height: null
			},
			ballPhysics: [],
			hitPhysics: []
		};
	},
	mounted() {
		const defaultManifest = [
				{ src: 'assets/balls/prestigelotto/number1.png', id: 'itemBall' },
				{ src: 'assets/item_ball_dim.png', id: 'itemBallDim' },
				{ src: 'assets/item_ball_guess.png', id: 'itemBallGuess' },
				{ src: 'assets/item_ball_hit.png', id: 'itemBallHit' },

				{ src: 'assets/item_ball_bg.png', id: 'itemBallBg' },
				{ src: 'assets/item_ball_shadow.png', id: 'itemBallShadow' },

				{ src: 'assets/item_sphere.png', id: 'itemSphere' },
				{ src: 'assets/item_stick.png', id: 'itemStick' },
				{ src: 'assets/item_shine.png', id: 'itemShine' },
				{ src: 'assets/item_bar.png', id: 'itemBar' },

				{ src: 'assets/item_prize_bg.png', id: 'itemPrizeBg' },
				{ src: 'assets/item_prize_select_bg.png', id: 'itemPrizeSelectBg' },

				{ src: 'assets/sounds/balls.ogg', id: 'soundBalls' },
				{ src: 'assets/sounds/reveal.ogg', id: 'soundReveal' },
				{ src: 'assets/sounds/startspin.ogg', id: 'soundStartSpin' },
				{ src: 'assets/sounds/win.ogg', id: 'soundWin' },
				{ src: 'assets/sounds/suck.ogg', id: 'soundSuck' },
				{ src: 'assets/sounds/cage.ogg', id: 'soundCage' }
			],
			manifest =
				this.manifest.length > 0
					? defaultManifest.reduce((acc, currentValue, index) => {
							const replaceableAsset = this.manifest.find(
								(x) => x.id === currentValue.id
							);

							if (replaceableAsset) {
								return [...acc, replaceableAsset];
							} else {
								return [...acc, currentValue];
							}
					  }, [])
					: defaultManifest;

		createjs.Sound.alternateExtensions = ['mp3'];
		this.loader.installPlugin(createjs.Sound);

		this.loader.addEventListener('complete', async () => {
			this.gameData.loaded = true;
			await this.$nextTick();
			var gameCanvas = this.$refs.gameCanvas;
			gameCanvas.width = stageW;
			gameCanvas.height = stageH;

			this.canvas.width = stageW;
			this.canvas.height = stageH;
			this.stage = new createjs.Stage('game');

			createjs.Touch.enable(this.stage);
			this.stage.enableMouseOver(20);
			this.stage.mouseMoveOutside = true;

			createjs.Ticker.framerate = 60;
			createjs.Ticker.addEventListener('tick', this.tick);

			this.buildGameCanvas();
			this.readyGame();
			this.startGame();

			this.$emit('ready');
		});
		this.loader.addEventListener('fileload', () => {
			console.log('File load completed.');
		});
		this.loader.addEventListener('error', (evt) => {
			console.error('An error has ocurred: ', evt);
		});
		this.loader.loadManifest(manifest);
	},
	methods: {
		tick(event) {
			requestAnimationFrame(() => {
				this.updateGame();
				this.stage.update(event);
			});
		},
		buildGameCanvas() {
			const gameContainer = new createjs.Container();
			ballsContainer = new createjs.Container(); // Move to Vue data.
			ballsRevealContainer = new createjs.Container();

			// const bg = new createjs.Bitmap(this.loader.getResult('background'));
			// logo = new createjs.Bitmap(this.loader.getResult('logo'));

			//game
			itemBall = new createjs.Bitmap(this.loader.getResult('itemBall'));
			centerReg(itemBall);
			itemBall.x = -500;

			itemBallBg = new createjs.Bitmap(this.loader.getResult('itemBallBg'));
			//centerReg(itemBallBg);
			itemBallBg.x = -500;

			itemBallShadow = new createjs.Bitmap(
				this.loader.getResult('itemBallShadow')
			);
			centerReg(itemBallShadow);
			itemBallShadow.x = -500;

			itemBallDim = new createjs.Bitmap(this.loader.getResult('itemBallDim'));
			centerReg(itemBallDim);
			itemBallDim.x = -500;

			itemBallGuess = new createjs.Bitmap(
				this.loader.getResult('itemBallGuess')
			);
			centerReg(itemBallGuess);
			itemBallGuess.x = -500;

			itemBallHit = new createjs.Bitmap(this.loader.getResult('itemBallHit'));
			centerReg(itemBallHit);
			itemBallHit.x = -500;

			itemSphere = new createjs.Bitmap(this.loader.getResult('itemSphere'));
			centerReg(itemSphere);
			itemStick = new createjs.Bitmap(this.loader.getResult('itemStick'));
			centerReg(itemStick);
			itemShine = new createjs.Bitmap(this.loader.getResult('itemShine'));
			centerReg(itemShine);

			itemSphere.x = this.gameData.sphereX;
			itemSphere.y = this.gameData.sphereY + 25;
			itemStick.x = this.gameData.sphereX;
			itemStick.y = this.gameData.sphereY;
			itemShine.x = this.gameData.sphereX;
			itemShine.y = this.gameData.sphereY;

			itemBar = new createjs.Bitmap(this.loader.getResult('itemBar'));
			centerReg(itemBar);
			itemBar.x = this.gameData.sphereX;
			itemBar.y = this.gameData.sphereY + 320;

			//? Magic variable to justify game horizontally.
			gameContainer.x = 130;

			gameContainer.addChild(
				// logo,
				itemBallBg,
				itemBallShadow,
				itemBall,
				itemBallDim,
				itemBallGuess,
				itemBallHit,
				ballsContainer,
				itemStick,
				itemSphere,
				itemShine,
				itemBar,
				ballsRevealContainer
			);

			this.canvasContainer.addChild(
				// bg,
				gameContainer
			);
			this.stage.addChild(this.canvasContainer);
		},
		updateBallRotate(ball, velX, velY, angle) {
			var targetBall = ball.obj;
			var targetRotateBall = ball.rotate;

			targetRotateBall.x += velX;
			targetRotateBall.y += velY;

			var end = -53;
			targetRotateBall.x = targetRotateBall.x > 0 ? end : targetRotateBall.x;
			targetRotateBall.x = targetRotateBall.x < end ? 0 : targetRotateBall.x;

			targetRotateBall.y = targetRotateBall.y > 0 ? end : targetRotateBall.y;
			targetRotateBall.y = targetRotateBall.y < end ? 0 : targetRotateBall.y;
		},
		renderPhysics() {
			for (var n = 0; n < this.ballPhysics.length; n++) {
				if (this.gameData.winArray.indexOf(n) != -1) {
					this.ballPhysics[n].body.velocity[0] = 0;
					this.ballPhysics[n].body.velocity[1] = 0;
				} else {
					this.ballPhysics[n].body.velocityTimer--;

					var x = this.ballPhysics[n].body.position[0],
						y = this.ballPhysics[n].body.position[1];

					var targetBall = this.gameData.ballsArray[n].obj;
					targetBall.x = this.canvas.width / 2 + x * scaleX;
					targetBall.y = this.canvas.height + y * scaleY;
					targetBall.rotation =
						(this.ballPhysics[n].body.angle * 180) / Math.PI;
				}

				if (this.settings.rotateBalls) {
					this.updateBallRotate(
						this.gameData.ballsArray[n],
						this.ballPhysics[n].body.velocity[0],
						this.ballPhysics[n].body.velocity[1],
						this.ballPhysics[n].body.angle
					);
				}
			}

			for (var n = 0; n < this.hitPhysics.length; n++) {
				var targetHit = this.gameData.cageArray[n];
				this.hitPhysics[n].body.position[0] =
					(targetHit.x - this.canvas.width / 2) / scaleX;
				this.hitPhysics[n].body.position[1] =
					(targetHit.y - this.canvas.height) / scaleY;
			}
		},
		updatePhysics() {
			this.world.step(1 / 60);
			this.renderPhysics();
		},
		spinCage() {
			for (var n = 0; n < this.gameData.cageArray.length; n++) {
				var targetHit = this.gameData.cageArray[n];
				var newPos = getAnglePositionByValue(
					this.gameData.sphereX,
					this.gameData.sphereY,
					this.gameData.cageRadius,
					targetHit.radius + this.gameData.radius
				);
				targetHit.x = newPos.x;
				targetHit.y = newPos.y;
			}
		},
		updateGame() {
			this.spinCage();
			this.updatePhysics();

			if (spinDirection) {
				this.gameData.radius -= radiusTweenData.radius;
				this.gameData.radius =
					this.gameData.radius < -360 ? 0 : this.gameData.radius;
			} else {
				this.gameData.radius += radiusTweenData.radius;
				this.gameData.radius =
					this.gameData.radius > 360 ? 0 : this.gameData.radius;
			}
			itemStick.rotation = itemShine.rotation = this.gameData.radius;
		},
		playSound(target, loop) {
			var isLoop;
			if (loop) {
				isLoop = -1;
				createjs.Sound.stop();
				musicLoop = createjs.Sound.play(
					target,
					createjs.Sound.INTERRUPT_NONE,
					0,
					0,
					isLoop,
					1
				);
				if (
					musicLoop == null ||
					musicLoop.playState == createjs.Sound.PLAY_FAILED
				) {
					return;
				} else {
					musicLoop.removeAllEventListeners();
					musicLoop.addEventListener('complete', function (musicLoop) {});
				}
			} else {
				isLoop = 0;
				createjs.Sound.play(target);
			}
		},
		startSpin() {
			this.playSound('soundStartSpin');

			this.status.spinning = true;

			for (var n = 0; n < this.revealArray.length; n++) {
				var currentNumber = this.revealArray[n];

				for (var p = 0; p < this.gameData.ballNumber.length; p++) {
					if (currentNumber == this.gameData.ballNumber[p].number) {
						this.gameData.ballNumber[p].status = true;
					}
				}
			}

			gsap.to(radiusTweenData, this.settings.spinStartSpeed, {
				radius: this.settings.spinSpeed,
				overwrite: true,
				onComplete: this.beginWinNumberTimer
			});
			gsap.to(soundTweenData, this.settings.spinStartSpeed, {
				volume: 1,
				overwrite: true,
				onUpdate: updateBallsVolume
			});
		},
		createCages() {
			var totalNum = 35;
			var wheelRadius = 360 / totalNum;

			for (var n = 0; n < totalNum; n++) {
				var currentRadius = wheelRadius * n;
				var newPos = getAnglePositionByValue(
					this.gameData.sphereX,
					this.gameData.sphereY,
					this.gameData.cageRadius,
					currentRadius
				);
				var newHit = itemBallHit.clone();
				newHit.x = newPos.x;
				newHit.y = newPos.y;
				newHit.radius = currentRadius;

				this.gameData.cageArray.push(newHit);
			}
		},
		readyGame() {
			for (var n = 0; n < this.settings.totalBall; n++) {
				this.gameData.totalBall.push(n % this.settings.maxNumber);
				this.createBall(n % this.settings.maxNumber);
			}

			this.createCages();
			this.createPhysics();
		},
		createBall(number) {
			var newBallContainer = new createjs.Container();
			var newBall = itemBallBg.clone();
			newBall.x = 0;
			newBall.y = 0;
			newBall.regX = 30;
			newBall.regY = 30;

			var newBallShadow = itemBallShadow.clone();
			newBallShadow.x = 0;
			newBallShadow.y = 0;

			var ballNumber;
			if (numberStartZero) {
				ballNumber = this.settings.padNumbers ? pad(number, 2) : number;
			} else {
				ballNumber = this.settings.padNumbers ? pad(number + 1, 2) : number + 1;
			}

			var space = 53;
			var newText = new createjs.Text();
			newText.font = '25px quantifybold';
			newText.color = '#000';
			newText.textAlign = 'center';
			newText.textBaseline = 'alphabetic';
			newText.text = ballNumber;
			newText.x = 0;
			newText.y = 10;

			var newText2 = new createjs.Text();
			newText2.font = '25px quantifybold';
			newText2.color = '#000';
			newText2.textAlign = 'center';
			newText2.textBaseline = 'alphabetic';
			newText2.text = ballNumber;
			newText2.x = space;
			newText2.y = 10;

			var newText3 = new createjs.Text();
			newText3.font = '25px quantifybold';
			newText3.color = '#000';
			newText3.textAlign = 'center';
			newText3.textBaseline = 'alphabetic';
			newText3.text = ballNumber;
			newText3.x = 0;
			newText3.y = space + 10;

			var newText4 = new createjs.Text();
			newText4.font = '25px quantifybold';
			newText4.color = '#000';
			newText4.textAlign = 'center';
			newText4.textBaseline = 'alphabetic';
			newText4.text = ballNumber;
			newText4.x = space;
			newText4.y = space + 10;

			var newBallInsideContainer = new createjs.Container();
			newBallInsideContainer.addChild(
				newBall,
				newText,
				newText2,
				newText3,
				newText4
			);

			var ballMask = new createjs.Shape();
			ballMask.graphics.beginFill('red').drawCircle(0, 0, 30);
			newBallInsideContainer.cache(-30, -30, 120, 120);
			newBallInsideContainer.mask = ballMask;

			newBallContainer.x = random(
				this.gameData.sphereX - 150,
				this.gameData.sphereX + 150
			);
			newBallContainer.y = this.gameData.sphereY;
			newBallContainer.addChild(newBallShadow, newBallInsideContainer);
			ballsContainer.addChild(newBallContainer);
			this.gameData.ballsArray.push({
				obj: newBallContainer,
				rotate: newBallInsideContainer,
				text: [newText, newText2, newText3, newText4]
			});
		},
		setRevealBalls() {
			ballsRevealContainer.removeAllChildren();
			var totalBalls = this.revealArray.length;
			var totalSplit = Math.floor(totalBalls / 2);
			var spaceX = 65;
			var startX = itemBar.x - spaceX * totalSplit;

			if (totalBalls % 2 === 0) {
				startX += spaceX / 2;
			}
			var startY = itemBar.y - 3;

			for (var n = 0; n < this.revealArray.length; n++) {
				if (n < this.gameData.winArray.length) {
					var currentBallRotate = this.gameData.ballsArray[
						this.gameData.winArray[n]
					].rotate;
					currentBallRotate.x = currentBallRotate.y = 0;
					var newGuessBall = this.gameData.ballsArray[
						this.gameData.winArray[n]
					].obj.clone(true);
					newGuessBall.x = startX;
					newGuessBall.y = startY;
				} else {
					var newGuessBall = itemBallGuess.clone();
					newGuessBall.x = startX;
					newGuessBall.y = startY;
				}

				ballsRevealContainer.addChild(newGuessBall);
				startX += spaceX;
			}
		},
		startGame() {
			this.gameData.winArray = [];
			this.gameData.radius = 0;
			this.gameData.numberNum = 0;
			radiusTweenData.radius = 0;

			const shuffleIndexArray = shuffle(
				Array.from({ length: this.settings.totalBall }, (_, i) => i)
			);

			for (var n = 0; n < this.settings.totalBall; n++) {
				var targetIndex = shuffleIndexArray[n];
				var targetBall = this.gameData.ballsArray[targetIndex].obj;
				targetBall.scaleX = targetBall.scaleY = 0.9;
				targetBall.x = random(
					this.gameData.sphereX - 100,
					this.gameData.sphereX + 100
				);
				targetBall.y = this.gameData.sphereY;
				ballsContainer.setChildIndex(targetBall, n);
			}
			this.resetBallsTimer();

			//randomize numbers
			this.gameData.ballNumber = [];

			this.gameData.totalBall = shuffle(this.gameData.totalBall);
			for (var n = 0; n < this.gameData.ballsArray.length; n++) {
				var currentNumber = Number(this.gameData.totalBall[n]);
				this.gameData.ballNumber.push({
					index: n,
					number: currentNumber,
					status: false
				});
				if (numberStartZero) {
					currentNumber = this.settings.padNumbers
						? pad(currentNumber, 2)
						: currentNumber;
				} else {
					currentNumber = this.settings.padNumbers
						? pad(currentNumber + 1, 2)
						: currentNumber + 1;
				}

				for (var p = 0; p < this.gameData.ballsArray[n].text.length; p++) {
					this.gameData.ballsArray[n].text[p].text = currentNumber;
					this.gameData.ballsArray[n].rotate.cache(-30, -30, 120, 120);
				}
			}

			this.setRevealBalls();
			playSoundLoop('soundBalls');
			setSoundVolume('soundBalls', 0.1);
			playSoundLoop('soundCage');
			setSoundVolume('soundCage', 0.1);
		},
		beginWinNumberTimer() {
			gsap.to(ballsContainer, this.settings.revealTimer, {
				overwrite: true,
				onComplete: this.revealWinNumber
			});
		},
		revealWinNumber() {
			var tweenNum = null;
			var revealNum = this.revealArray[this.gameData.numberNum];

			var findBallClone = false;
			for (var p = 0; p < this.gameData.ballNumber.length; p++) {
				if (tweenNum == this.gameData.ballNumber[p].number) {
					findBallClone = true;
					tweenNum = this.gameData.ballNumber[p].index;
					break;
				}
			}

			if (!findBallClone) {
				for (var p = 0; p < this.gameData.ballNumber.length; p++) {
					if (!this.gameData.ballNumber[p].status) {
						this.gameData.ballNumber[p].status = true;
						tweenNum = this.gameData.ballNumber[p].index;
						p = this.gameData.ballNumber.length;
					}
				}
			}

			this.gameData.revealIndex = tweenNum;
			this.gameData.winArray.push(tweenNum);

			var targetBall = this.gameData.ballsArray[tweenNum].obj;
			var targetBallRotate = this.gameData.ballsArray[tweenNum].rotate;
			var currentNumber = this.revealArray[this.gameData.numberNum];
			if (numberStartZero) {
				currentNumber = this.settings.padNumbers
					? pad(currentNumber, 2)
					: currentNumber;
			} else {
				currentNumber = this.settings.padNumbers
					? pad(currentNumber + 1, 2)
					: currentNumber + 1;
			}
			for (var p = 0; p < this.gameData.ballsArray[tweenNum].text.length; p++) {
				this.gameData.ballsArray[tweenNum].text[p].text = currentNumber;
				this.gameData.ballsArray[tweenNum].rotate.cache(-30, -30, 120, 120);
			}
			this.gameData.numberNum++;

			this.playSound('soundSuck');
			gsap.to(targetBallRotate, 0.5, {
				x: 0,
				y: 0,
				rotation: 0,
				overwrite: true
			});
			gsap.to(targetBall, 0.5, {
				x: this.gameData.sphereX,
				y: (this.canvas.height / 100) * 80,
				rotation: 0,
				scaleX: 1,
				scaleY: 1,
				overwrite: true,
				onComplete: () => {
					this.playSound('soundReveal');
					this.setRevealBalls();

					gsap.to(targetBall, 0.2, {
						delay: 1,
						x: this.gameData.sphereX,
						y: (this.canvas.height / 100) * 98,
						rotation: 0,
						overwrite: true
					});
				}
			});

			if (this.gameData.numberNum < this.revealArray.length) {
				this.beginWinNumberTimer();
			} else {
				this.endGame();
			}
		},
		endGame() {
			gsap.to(radiusTweenData, this.settings.spinEndSpeed, {
				radius: 0,
				overwrite: true
			});
			gsap.to(soundTweenData, this.settings.spinEndSpeed, {
				volume: 0.1,
				overwrite: true,
				onUpdate: updateBallsVolume
			});

			gsap.to(ballsContainer, 4, {
				overwrite: true,
				onComplete: () => {
					this.$emit('finish');
				}
			});
		},
		checkCollision(eq) {
			var enable = true;

			if (
				eq.bodyA.contactType === 'ball' &&
				eq.bodyB.contactType === 'cage' &&
				this.gameData.winArray.indexOf(eq.bodyA.index) != -1
			) {
				enable = false;
			} else if (
				eq.bodyA.contactType === 'ball' &&
				eq.bodyB.contactType === 'cage' &&
				this.gameData.winArray.indexOf(eq.bodyA.index) != -1
			) {
				enable = false;
			} else if (
				eq.bodyA.contactType === 'cage' &&
				eq.bodyB.contactType === 'ball' &&
				this.gameData.winArray.indexOf(eq.bodyB.index) != -1
			) {
				enable = false;
			} else if (
				eq.bodyA.contactType === 'ball' &&
				eq.bodyB.contactType === 'ball'
			) {
				enable = false;
			}
			return enable;
		},
		createPhysics() {
			var ballMaterial = new p2.Material();
			var cageMaterial = new p2.Material();

			for (var n = 0; n < this.gameData.ballsArray.length; n++) {
				this.ballPhysics.push({
					shape: '',
					body: '',
					material: '',
					property: { radius: ballRadius / scaleX / 2 },
					position: [0, 0]
				});

				this.ballPhysics[n].shape = new p2.Circle(this.ballPhysics[n].property);
				this.ballPhysics[n].material = ballMaterial;
				this.ballPhysics[n].shape.material = this.ballPhysics[n].material;
				this.ballPhysics[n].body = new p2.Body({
					mass: 1,
					position: this.ballPhysics[n].position
				});
				this.ballPhysics[n].body.addShape(this.ballPhysics[n].shape);

				this.ballPhysics[n].body.position[0] =
					(this.gameData.ballsArray[n].obj.x - this.canvas.width / 2) / scaleX;
				this.ballPhysics[n].body.position[1] =
					(this.gameData.ballsArray[n].obj.y - this.canvas.height) / scaleY;
				this.ballPhysics[n].body.contactType = 'ball';
				this.ballPhysics[n].body.velocityTimer = 0;
				this.ballPhysics[n].body.index = n;
				this.resetBallTimer(this.ballPhysics[n].body);

				this.world.addBody(this.ballPhysics[n].body);
			}

			for (var n = 0; n < this.gameData.cageArray.length; n++) {
				this.hitPhysics.push({
					shape: '',
					body: '',
					material: '',
					property: { radius: 10 / scaleX / 2 },
					position: [0, 0]
				});

				this.hitPhysics[n].shape = new p2.Circle(this.hitPhysics[n].property);
				this.hitPhysics[n].material = cageMaterial;
				this.hitPhysics[n].shape.material = this.hitPhysics[n].material;
				this.hitPhysics[n].body = new p2.Body({
					mass: 0,
					position: this.hitPhysics[n].position
				});
				this.hitPhysics[n].body.addShape(this.hitPhysics[n].shape);

				this.hitPhysics[n].body.position[0] =
					(this.gameData.cageArray[n].x - this.canvas.width / 2) / scaleX;
				this.hitPhysics[n].body.position[1] =
					(this.gameData.cageArray[n].y - this.canvas.height) / scaleY;
				this.hitPhysics[n].body.contactType = 'cage';

				this.world.addBody(this.hitPhysics[n].body);
			}

			this.world.on('beginContact', (evt) => {
				if (
					evt.bodyA.contactType == 'ball' &&
					evt.bodyB.contactType == 'cage'
				) {
					this.setBallVelocity(evt.bodyA);
				} else if (
					evt.bodyA.contactType == 'cage' &&
					evt.bodyB.contactType == 'ball'
				) {
					this.setBallVelocity(evt.bodyB);
				}
			});

			// Disable any equations between the current passthrough body and the character
			this.world.on('preSolve', (evt) => {
				for (var i = 0; i < evt.contactEquations.length; i++) {
					var eq = evt.contactEquations[i];
					eq.enabled = this.checkCollision(eq);

					if (
						eq.bodyA.contactType == 'ball' &&
						eq.bodyB.contactType == 'cage'
					) {
						this.setBallVelocity(eq.bodyA);
					} else if (
						eq.bodyA.contactType == 'cage' &&
						eq.bodyB.contactType == 'ball'
					) {
						this.setBallVelocity(eq.bodyB);
					}
				}

				for (var i = 0; i < evt.frictionEquations.length; i++) {
					var eq = evt.frictionEquations[i];
					eq.enabled = this.checkCollision(eq);

					if (
						eq.bodyA.contactType == 'ball' &&
						eq.bodyB.contactType == 'cage'
					) {
						this.setBallVelocity(eq.bodyA);
					} else if (
						eq.bodyA.contactType == 'cage' &&
						eq.bodyB.contactType == 'ball'
					) {
						this.setBallVelocity(eq.bodyB);
					}
				}
			});

			this.world.on('endContact', function (evt) {});
		},
		resetBallTimer(targetBody) {
			targetBody.velocityTimer = random(30, 100);
		},
		resetBallsTimer() {
			for (var n = 0; n < this.ballPhysics.length; n++) {
				this.ballPhysics[n].body.position[0] =
					(this.gameData.ballsArray[n].obj.x - this.canvas.width / 2) / scaleX;
				this.ballPhysics[n].body.position[1] =
					(this.gameData.ballsArray[n].obj.y - this.canvas.height) / scaleY;
				this.resetBallTimer(this.ballPhysics[n].body);
			}
		},
		setBallVelocity(targetBody) {
			if (this.gameData.winArray.indexOf(targetBody.index) != -1) {
				return;
			}

			if (targetBody.velocityTimer < 0) {
				var veloX = 0;
				var veloY = 0;

				if (radiusTweenData.radius < 3) {
					veloX = random(-3, 3);
					veloY = random(2, 5);
				} else if (radiusTweenData.radius < 8) {
					veloX = random(-3, 5);
					veloY = random(5, 10);
				} else {
					veloX = random(-3, 10);
					veloY = random(10, 20);
				}

				targetBody.velocity[0] += veloX;
				targetBody.velocity[1] += veloY;
				this.resetBallTimer(targetBody);
			}
		},
		stopGame() {
			stopSoundLoop('soundBalls');
			stopSoundLoop('soundCage');

			this.status.spinning = false;
			this.gameData.winArray = [];
			// this.revealArray = [];
			this.gameData.radius = 0;
			radiusTweenData.radius = 0;
			gsap.globalTimeline.clear();
			createjs.Sound.removeAllSounds();
			createjs.Sound.removeAllEventListeners();

			ballsRevealContainer.removeAllChildren();
		}
	},
	destroyed() {
		this.stage.removeAllChildren();
		this.world.clear();
		this.state;
		this.stage.update();
		createjs.Ticker.removeEventListener('tick', this.tick);
		this.stopGame();
	}
});
</script>
